/* ============================================================================
   Toalla Exfoliante de Ducha XELAE, FILET DE SECURITE DU PANIER.

   Defaut signale le 07-08-2026 au soir : « le panier reste vide lorsqu'on veut
   ajouter un article ». Mesure : les 9 combinaisons pack x couleur reussissent
   dans un Chrome ordinaire. L'echec ne vient donc pas du choix de variante.

   Ce qui se passe : /cart/add.js peut repondre 200 SANS que le cookie de panier
   soit conserve (iframe de l'editeur de theme, cookies tiers partitionnes ou
   bloques, protection anti-pistage). Le script principal faisait confiance a ce
   200, ouvrait le tiroir, et le tiroir lisait /cart.js qui renvoyait un panier
   VIDE. D'ou le symptome exact.

   Ce fichier ne modifie pas le script principal : il l'observe. Apres un clic
   sur le bouton d'ajout, il RELIT le panier. Si le panier est toujours vide,
   c'est que l'ajout n'a pas persiste, et il repasse par un VRAI envoi de
   formulaire vers /cart/add. Une soumission de formulaire est une navigation de
   premier niveau : les cookies y passent la ou l'appel AJAX echoue.

   Le formulaire porte `return_to`, qui ramene sur LA FICHE, jamais sur /cart
   (§31.13), avec un marqueur qui rouvre le tiroir a l'arrivee.
   ============================================================================ */
(function () {
  'use strict';

  var ATTENTE = 2600;   /* laisse au script principal le temps de son appel AJAX */
  var MARQUEUR = 'toa_panier';

  /* JAMAIS dans l'editeur de theme, ni dans aucune iframe. Mesure du 08-08-2026 :
     Shopify pose le cookie de panier en `SameSite=Lax`, sans `Partitioned`. Sous
     l'editeur la vitrine est affichee dans une iframe de admin.shopify.com, donc
     en contexte cross-site : le cookie n'est ni envoye ni conserve, /cart/add.js
     repond 200 et /cart.js repond vide, a chaque fois. Le panier ne PEUT pas
     fonctionner la, pour aucun theme.

     Le filet croyait donc a un echec et partait en envoi de formulaire, soit une
     navigation de premier niveau que l'editeur ne sait pas suivre : c'est l'ecran
     « Cette page n'est pas compatible avec l'editeur, la page redirige vers une
     URL non prise en charge » signale par l'utilisateur. Dans une iframe le
     formulaire n'aurait de toute facon rien resolu, le cookie y est bloque pour
     la meme raison. */
  var SOUS_IFRAME = (function () {
    try { return window.top !== window.self; } catch (e) { return true; }
  })();
  var EDITEUR = !!(window.Shopify && window.Shopify.designMode) || SOUS_IFRAME;

  function racine() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (r) return r.replace(/\/$/, '');
    var ici = (location.pathname.match(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i) || [''])[0];
    return ici;
  }

  function lirePanier() {
    return fetch(racine() + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  /* Variante choisie, relue dans le DOM : la carte d'offre selectionnee donne le
     pack, sa premiere pastille active donne la couleur. On ne touche pas a l'etat
     interne du script principal, on lit ce qui est affiche. */
  function varianteChoisie() {
    var D = window.toallaExfolianteData || {};
    var carte = document.querySelector('.toalla-exfoliante-offer.is-selected');
    if (!carte) carte = document.querySelector('[data-toalla-exfoliante-pack]');
    if (!carte) return null;
    var pack = carte.getAttribute('data-toalla-exfoliante-pack');
    if (!pack) {
      var p = carte.querySelector('[data-toalla-exfoliante-pack]');
      pack = p && p.getAttribute('data-toalla-exfoliante-pack');
    }
    var couleurs = [];
    var unites = carte.querySelectorAll('[data-toalla-exfoliante-unit]');
    for (var u = 0; u < unites.length; u++) {
      var actif = unites[u].querySelector('[data-toalla-exfoliante-color].is-selected');
      if (actif) couleurs.push(actif.getAttribute('data-toalla-exfoliante-color'));
    }
    if (!couleurs.length && D.defaultColor) couleurs.push(D.defaultColor);

    var liste = D.variants || [];
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].pack === pack && liste[i].color === couleurs[0]) {
        return { id: liste[i].id, couleurs: couleurs, label: D.colorLabel || 'Color' };
      }
    }
    return null;
  }

  /* Envoi de formulaire natif. Pas de fetch, pas d'AJAX : une vraie navigation. */
  function envoiFormulaire(v) {
    var retour = location.pathname + location.search
      + (location.search ? '&' : '?') + MARQUEUR + '=1';

    var f = document.createElement('form');
    f.method = 'post';
    f.action = racine() + '/cart/add';
    f.style.display = 'none';

    function champ(nom, valeur) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = nom;
      i.value = valeur;
      f.appendChild(i);
    }
    champ('id', v.id);
    champ('quantity', '1');
    champ('return_to', retour);
    /* Couleurs par unite, memes cles que l'appel AJAX : la preparation de
       commande doit savoir quoi expedier. */
    if (v.couleurs.length > 1) {
      for (var i = 0; i < v.couleurs.length; i++) {
        champ('properties[' + v.label + ' #' + (i + 1) + ']', v.couleurs[i]);
      }
    }
    document.body.appendChild(f);
    f.submit();
  }

  /* Ecouteur sur DOCUMENT, pas sur le bouton.

     Corrige le 08-08-2026. Le filet se posait sur le noeud trouve au demarrage,
     exactement comme le script principal. Quand Shopify remplace la section
     (editeur de theme, rechargement a chaud de l'apercu du brouillon), les deux
     ecouteurs partent avec le noeud detache : le clic sur « Anadir al carrito »
     ne declenche plus rien du tout, et le filet ne rattrape rien puisqu'il est
     mort lui aussi. Un ecouteur delegue sur document survit a tout
     remplacement. */
  function surveiller() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('[data-toalla-exfoliante-add]')) return;
      var v = varianteChoisie();
      if (!v) return;
      setTimeout(function () {
        lirePanier().then(function (panier) {
          var vide = !panier || !panier.items || panier.items.length === 0;
          if (!vide) return;                /* l'ajout a bien pris, rien a faire */
          /* Le panier est vide alors qu'on vient de cliquer : l'appel AJAX n'a
             pas persiste. On repasse par le formulaire. */
          envoiFormulaire(v);
        });
      }, ATTENTE);
    });
  }

  /* Retour du formulaire : rouvrir le tiroir et nettoyer l'URL. */
  function retourFormulaire() {
    if (location.search.indexOf(MARQUEUR + '=1') === -1) return;
    var ouvre = function () {
      var b = document.querySelector('[data-toalla-exfoliante-cart-open]');
      if (b) b.click();
    };
    /* le script principal est en defer : on attend qu'il ait pose ses ecouteurs */
    setTimeout(ouvre, 600);
    setTimeout(ouvre, 1800);
    try {
      var propre = location.search
        .replace(new RegExp('[?&]' + MARQUEUR + '=1'), '')
        .replace(/^&/, '?');
      history.replaceState({}, '', location.pathname + propre + location.hash);
    } catch (e) {}
  }

  function demarrer() {
    if (EDITEUR) return;      /* voir EDITEUR ci-dessus : aucune navigation ici */
    surveiller();
    retourFormulaire();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
